<template>
  <div style="display: flex; max-height: 100%; height: 100%">
    <v-textarea
      hide-details
      no-resize
      v-model="$attrs.value"
      style="max-height: 100%; border-top: none !important; margin-top: 0"
      single-line
      :placeholder="$props.placeholder"
      @click="hidePicker"
      @blur="textArea"
      @keydown.enter="submit"
      @input="$emit('input', $attrs.value)"
      rows="1"
      height="100%"
      dense
      color="rgba(0,0,0,.54) "
      ref="textarea"
      prepend-inner-icon="mdi-emoticon-outline"
      @click:prepend-inner.stop="togglePicker"
    >
    </v-textarea>
    <EmojiPicker
      v-if="showPicker"
      @click.stop="textArea"
      @addEmoji="addEmoji"
      class="emojiPicker"
      ref="emojiPicker"
    />
    <!-- <textarea ref="textarea" v-model="message" @blur="textArea"></textarea>
    <EmojiPicker @addEmoji="addEmoji" class="emojiPicker" /> -->
  </div>
</template>

<script>
import EmojiPicker from "./emojiPicker.vue";
export default {
  name: "EmojiTextArea",
  components: {
    EmojiPicker,
  },
  props: {
    placeholder: {
      type: String,
    },
  },

  data() {
    return {
      message: "Hello Vue!",
      lastPosition: 0,
      showPicker: false,
    };
  },
  mounted() {
    let OS = navigator.platform === "Win32" ? "Windows" : "Other";
    document.querySelectorAll("style")[0].innerHTML += `textarea {
    margin: 0 !important;
    padding-right: 20px !important;
    font-family: ${
      OS === "Windows"
        ? "'Open Sans', 'Noto Color Emoji'"
        : "'Open Sans', sans-serif !important;"
    } !important;
  }`;
  },

  methods: {
    togglePicker() {
      this.showPicker = !this.showPicker;
      this.$emit("click");
    },
    submit(event) {
      if (!event.shiftKey) {
        this.$emit("enter", this.$attrs.value);
        this.$attrs.value = "";
        event.preventDefault();
      }
    },
    addEmoji(emoji) {
      let start = this.$attrs.value.slice(0, this.lastPosition);
      let end = this.$attrs.value.slice(this.lastPosition);
      this.$attrs.value = start + emoji.native + end;
      this.lastPosition = this.lastPosition + emoji.native.length;
      let input = this.$refs.textarea.$refs.input;
      this.$nextTick().then(() => {
        this.$emit("input", this.$attrs.value);
        input.focus();
        this.$nextTick(() => {
          input.selectionStart = this.lastPosition;
          input.selectionEnd = this.lastPosition;
        });
      });
    },
    textArea() {
      this.$nextTick(() => {
        this.lastPosition = this.$refs.textarea.$refs.input.selectionStart;
      });
      // this.hidePicker();
    },
    hidePicker() {
      this.showPicker = false;
    },
    open(event) {
      this.isOpen = event;
    },
  },
};
</script>
<style>
.v-input__control {
  height: 100% !important;
}
.v-text-field__slot {
  height: 100%;
}
</style>
